import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { APP_ROLE, SOCKET_ERROR, SocketService } from '../../shared/services/socket.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { FormSettings } from '../../shared/models/game-settings.model';
import { StorageService } from '../../shared/services/storage.service';
import { GameService } from '../../shared/services/game.service';

@Component({
  selector: 'app-digi-connect',
  templateUrl: './digi-connect.component.html',
  styleUrls: ['./digi-connect.component.scss']
})
export class DigiConnectComponent implements OnInit {

  codeForm: FormGroup;
  focus: number = -1;
  feedback: string = 'Wachten op verbinding met spelleiderscherm';
  error: boolean;

  constructor(private storageService: StorageService, private socketService: SocketService, private gameService: GameService, private router: Router, private fb: FormBuilder) { }

  ngOnInit() {

    this.codeForm = this.fb.group({
      codeInputs: new FormArray([
        new FormControl('', Validators.required),
        new FormControl('', Validators.required),
        new FormControl('', Validators.required),
        new FormControl('', Validators.required),
        new FormControl('', Validators.required)])
    });

    this.focus = 0;
  }

  get codeInputs(): FormArray { return this.codeForm.get('codeInputs') as FormArray; }

  onCodeInput(inputValue) {
    // console.log(inputValue);

    if (!this.codeForm.invalid) {
      this.onFormSubmit();
    } else {
      if (inputValue != '') {
        // focus to next input
        if (this.focus < this.codeInputs.length) {
          this.focus++;
        }
      }
    }
  }

  onCodeInputFocus(input, focusNumber) {
    this.focus = focusNumber;
    this.codeInputs.at(focusNumber).reset('')
  }

  copyPasta(event) {
    const text: string = event.clipboardData.getData('text/plain');
    const arr = text.split('');
    if (arr.length === 5) {
      this.codeForm.setValue({
        codeInputs: arr
      });
      // console.log(arr);
    }
  }

  onBackspace(event) {
    // console.log(event);
    if (this.focus > 0) {
      this.focus--;
    }
  }

  onBlur(event) {
    // console.log(event);
    if (!this.codeForm.invalid) {
      this.onFormSubmit();
    }
  }

  onFormSubmit() {
    const form = this.prepareSaveForm();
    const sessionCode = form.codeInputs.join('');

    // console.log(sessionCode);
    this.initConnection(sessionCode)
  }

  prepareSaveForm(): FormSessionCode {

    const formModel = this.codeForm.value;

    const form: FormSessionCode = {
      codeInputs: formModel.codeInputs
    };

    return form;
  }

  private initConnection(sessionCode): void {

    this.socketService.initSocket(sessionCode, APP_ROLE.DIGI_ROLE);

    this.socketService.onSocketError().subscribe( (data) => {

      this.error = true;

      if( data.errorType === SOCKET_ERROR.NO_REMOTE_DETECTED) {
        this.feedback = 'Oeps, het lijkt erop dat ik het spelleiderscherm niet kan vinden.';
      }
      if( data.errorType === SOCKET_ERROR.NO_SESSION_DETECTED) {
        this.feedback = 'Helaas, met deze code kan ik geen verbinding maken.';
      }
      if( data.errorType === SOCKET_ERROR.MISSING_SESSION_CODE_AND_ROLE) {
        this.feedback = 'Helaas, met deze code kan ik geen verbinding maken.';
      }

    });

    this.socketService.onDigiConnection().subscribe( () => {

      this.error = false;

      this.gameService.sessionCode = sessionCode;
      console.log('this.gameService.sessionCode', this.gameService.sessionCode);

      this.storageService.setSessionCode(sessionCode)
        .subscribe(data => {
          console.log('storageservice setsesioncode data:', data)
          this.router.navigate(['digi/game']);
        })


    });
  }

}

export interface FormSessionCode {
  codeInputs: string[];
}



// WEBPACK FOOTER //
// ./src/app/digi/digi-connect/digi-connect.component.ts